import { Table } from "antd";
import React from "react";
import Pagination from "../Common/CommonPagination";
import scroll from "../../assets/webp/scroll.webp";

const ListPageLayout = ({
  breadcrumbs,
  addButton,
  titles,
  filters,
  tableProps,
  totalCount,
  pagination,
  onPageChange,
  children,
  loader,
}) => {
  return (
    <div className="healtharticle-container healthsyContainer">
      <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
        {breadcrumbs}
        <div className="d-flex gap-4 align-items-center">{addButton}</div>
      </div>
      {titles}
      {filters}
      {!loader ? (
        <Table
          bordered
          pagination={false}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          className="mx-3 pt-2 table-scrollable masterList_table"
          {...tableProps}
        />
      ) : (
        <div className="d-flex justify-content-center">
          <img src={scroll} width={150} alt="loader" />
        </div>
      )}

      <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
        <div className="border border-danger bg-bg-light px-2 py-1 rounded">
          Total Count: {totalCount}
        </div>
        {totalCount > pagination.limit && (
          <Pagination
            skip={pagination.skip}
            limit={pagination.limit}
            total={totalCount}
            onPageChange={onPageChange}
          />
        )}
      </div>

      {children}
    </div>
  );
};

export default ListPageLayout;
